<template>
  <div class="deck-comments mb-4">
    <h2>Comments</h2>
    <template v-if="comments">
      <DeckSingleComment
        :comment="comment"
        v-for="(comment, idx) in comments"
        ref="singleComment"
        :id="`comment-${comment.id}`"
        :highlight="comment.id == highlightedComment ? 'info' : null"
        :key="$id(comment.id)"
        @submit:reply="submitReply($event, comment.id, idx)"
      />
      <span v-if="comments.length === 0">
        There are no comments yet. Why don't you start the conversation?
      </span>
    </template>
    <span v-else> Loading comments... </span>
    <hr class="my-4" />
    <div class="mx-4">
      <b-alert show>Remember, <strong>be nice</strong>!</b-alert>
      <CommentEditor
        class=""
        v-model="commentBody"
        ref="editor"
        @submit:comment="submitComment"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api.js";
import DeckSingleComment from "@/components/comments/DeckSingleComment.vue";
import CommentEditor from "@/components/comments/CommentEditor.vue";

export default {
  components: { DeckSingleComment, CommentEditor },
  name: "DeckComments",
  data() {
    return {
      commentBody: "",
    };
  },
  props: {
    deckId: {
      type: String,
      required: true,
    },
  },
  computed: {
    highlightedComment() {
      const hash = this.$route.hash;
      if (hash.startsWith("#comment-")) {
        return hash.substring(9);
      }
      return null;
    },
  },
  asyncComputed: {
    async comments() {
      const data = await api.getDeckComments(this.deckId);
      return data;
    },
  },
  methods: {
    async submitReply(body, replyTo, idx) {
      try {
        const response = await api.commentOnDeck(this.deckId, body, replyTo);
        this.refresh();
        this.$router.push({ hash: `comment-${response}` });
        this.$refs.singleComment[idx].clear();
        this.$root.$bvToast.toast("Your reply has been posted", {
          variant: "success",
        });
      } catch (err) {
        console.error(err);
        this.$root.$bvToast.toast("There was a problem posting your reply", {
          variant: "danger",
        });
      }
    },
    async submitComment(body) {
      try {
        const response = await api.commentOnDeck(this.deckId, body);
        this.refresh();
        this.$router.push({ hash: `comment-${response}` });
        this.commentBody = "";
        this.$root.$bvToast.toast("Your comment has been posted", {
          variant: "success",
        });
      } catch (err) {
        console.error(err);
        this.$root.$bvToast.toast("There was a problem posting your comment", {
          variant: "danger",
        });
      }
    },
    refresh() {
      this.$asyncComputed.comments.update();
    },
  },
};
</script>
